<section class="mt-grid in10" :class="$style.marginBtm29" v-if="isSet()">
  <div class="row mt-line">
    <div class="col is5 is10-xs is10-s">
      <label
        :for="$vId(this, 'designers')"
        class="mt-serif--bold mt-label--capitalise mt-label--black mt-label--size20"
      >
        {{$t('pages.submissions.components.upload.fontmeta.designers.label')}}
      </label>
      <p v-html="$sanitize($t('pages.submissions.components.upload.fontmeta.designers.description'))" :class="$style.designerLabelSection">
      </p>
      <vee-field
        name="designers upload"
        label="designers"
        rules="submission_designer_required|not_empty"
        v-slot="{field, errorMessage}"
        v-model="designers.values"
      >
        <fou-select
          ref="fouSelectDesigners"
          multiple
          tags-outside
          deselect-from-dropdown
          :clear-search-on-blur="false"
          name="designers upload"
          :class="[$style.inputFont, $style.inputWidth2]"
          :id="$vId(this, 'existing-designers')"
          :options="designers.options"
          :model-value="designers.values"
          :reduce="op => op"
          :hide-drop="hideDrop"
          @search="getDesignerOptions"
          @search:blur="onSearchBlur"
          @option:selected="updateDesignersValues"
          @option:deselected="optionDeselected"
          :close-on-select="false"
          :is-error="Object.hasOwn(errors, 'designers upload')"
          :placeholder="$t('pages.submissions.components.upload.fontmeta.designers.placeholder')"
          see="na"
          type="checkbox"
          class-name="mt-checkbox"
        />
        <p class="ml-0 mt-error">{{errorMessage}}</p>
      </vee-field>
    </div>
  </div>
  <div class="row mt-group">
    <div class="col is10">
      <fou-select-tags
        :id="$vId(this, 'designers-selection')"
        :fou-select="designers"
        :fou-select-id="$vId(this, 'designers')"
        @on:remove="validateDesigners"
        :class="$style.createdTags"
      >
      </fou-select-tags>
    </div>
  </div>
</section>
